import { SteelSpacingGroupOptions } from './constants';
import CTAButton from '../../../../CTAButton';
import OcLabel from '../../../../ComponentLibrary/input-elements/oc-label';
import { QuestionWrapper, SubQuestionWrapper } from '../../styles';
import { CODEBORD_THICKNESS_OPTIONS, RAINBARRIER_THICKNESS_OPTIONS } from '../shared/constants';
import { DropdownField, RadioList, Section, YesNo } from '../shared/formControls';

/* eslint-disable react/prop-types */
// TODO: Move WallsAboveGrade state variables to a single object to reduce prop drilling
export const Sidebar = props => {
  const {
    calcId,
    studsKind,
    setStudsKind,
    woodSize,
    setWoodSize,
    spacingWood,
    setSpacingWood,
    cavityRSIWood,
    setCavityRSIWood,
    cavityChoicesWood = [],
    steelSize,
    setSteelSize,
    steelSpacingGroup,
    setSteelSpacingGroup,
    cavityRSISteel,
    setCavityRSISteel,
    cavityChoicesSteel = [],
    cladding,
    setCladding,
    hardieThickness,
    setHardieThickness,
    sheathingType,
    setSheathingType,
    osbThickness,
    setOsbThickness,
    gwbSheathThickness,
    setGwbSheathThickness,
    hasExteriorInsulation,
    setHasExteriorInsulation,
    exteriorInsulationType,
    setExteriorInsulationType,
    exteriorCodebordInches,
    setExteriorCodebordInches,
    exteriorRainbarrierInches,
    setExteriorRainbarrierInches,
    hasWeatherBarrier,
    setHasWeatherBarrier,
    hasVapourBarrier,
    setHasVapourBarrier,
    interiorGWB,
    setInteriorGWB,
    woodStrapBehindGWB,
    setWoodStrapBehindGWB,
    onCalculate,
    onReset,
    hasLocation,
    t,
  } = props;

  const resetExteriorInsulation = () => {
    setExteriorInsulationType('');
    setExteriorCodebordInches('');
    setExteriorRainbarrierInches('');
  };

  const onSetSheathingType = e => {
    resetExteriorInsulation();
    setSheathingType(e.target.value);
  };

  return (
    <>
      <Section title={t('thermal_calculator.non_continuous_layers')}>
        <QuestionWrapper>
          <OcLabel forId={`studsKind-${calcId}`} text={t('thermal_calculator.walls_above_grade.type_of_studs')} />
          <DropdownField
            id={`studsKind-${calcId}`}
            name="type-of-studs"
            value={studsKind}
            onChange={e => setStudsKind(e.target.value)}
            options={[
              { value: 'steel', text: t('thermal_calculator.walls_above_grade.steel_studs') },
              { value: 'wood', text: t('thermal_calculator.walls_above_grade.wood_studs') },
            ]}
          />
        </QuestionWrapper>

        {studsKind === 'wood' ? (
          <>
            <QuestionWrapper>
              <OcLabel forId={`wood-framing-type-${calcId}`} text={t('thermal_calculator.framing_type')} />
              <DropdownField
                id={`wood-framing-type-${calcId}`}
                name="framing-type"
                value={woodSize}
                onChange={e => {
                  setWoodSize(e.target.value);
                  setCavityRSIWood('');
                }}
                options={['2x4', '2x6', '2x8', '2x10'].map(sz => ({
                  value: sz,
                  text: `${t('thermal_calculator.walls_above_grade.wood_studs')} ${sz}`,
                }))}
              />
            </QuestionWrapper>

            <QuestionWrapper>
              <OcLabel
                forId={`spacing-wood-${calcId}`}
                text={t('thermal_calculator.floors_over_unheated_spaces.framing_on_center')}
              />
              <DropdownField
                id={`spacing-wood-${calcId}`}
                name="framing-on-center"
                value={spacingWood}
                onChange={e => setSpacingWood(e.target.value)}
                options={[
                  { value: '304', text: t('thermal_calculator.dimensions.spacing_304') },
                  { value: '406', text: t('thermal_calculator.dimensions.spacing_406') },
                  { value: '488', text: t('thermal_calculator.dimensions.spacing_488') },
                  { value: '610', text: t('thermal_calculator.dimensions.spacing_610') },
                ]}
              />
            </QuestionWrapper>

            <QuestionWrapper>
              <OcLabel
                forId={`cavityWood-${calcId}`}
                text={t('thermal_calculator.floors_over_unheated_spaces.cavity_nominal_rsi')}
              />
              <DropdownField
                id={`cavityWood-${calcId}`}
                name="cavity-nominal-rsi"
                value={cavityRSIWood}
                onChange={e => setCavityRSIWood(e.target.value)}
                disabled={cavityChoicesWood.length === 0}
                options={cavityChoicesWood}
              />
            </QuestionWrapper>
          </>
        ) : (
          <>
            <div>
              <OcLabel text={t('thermal_calculator.framing_type')} />
              <RadioList
                name={`steel-size-${calcId}`}
                value={steelSize}
                onChange={sz => {
                  setSteelSize(sz);
                  setCavityRSISteel('');
                }}
                options={[
                  {
                    value: '2x4',
                    label: `${t('thermal_calculator.walls_above_grade.steel_studs')} 2x4 (38 mm x 92 mm)`,
                  },
                  {
                    value: '2x6',
                    label: `${t('thermal_calculator.walls_above_grade.steel_studs')} 2x6 (38 mm x 152 mm)`,
                  },
                  {
                    value: '2x8',
                    label: `${t('thermal_calculator.walls_above_grade.steel_studs')} 2x8 (38 mm x 203 mm)`,
                  },
                  {
                    value: '2x10',
                    label: `${t('thermal_calculator.walls_above_grade.steel_studs')} 2x10 (38 mm x 254 mm)`,
                  },
                ]}
              />
            </div>

            <div>
              <OcLabel text={t('thermal_calculator.floors_over_unheated_spaces.framing_on_center')} />
              <RadioList
                name={`steel-spacing-${calcId}`}
                value={steelSpacingGroup}
                onChange={setSteelSpacingGroup}
                options={SteelSpacingGroupOptions}
              />
            </div>

            <div>
              <OcLabel
                forId={`cavitySteel-${calcId}`}
                text={t('thermal_calculator.floors_over_unheated_spaces.cavity_nominal_rsi')}
              />
              <DropdownField
                id={`cavitySteel-${calcId}`}
                name="cavity-nominal-rsi"
                value={cavityRSISteel}
                onChange={e => setCavityRSISteel(e.target.value)}
                options={cavityChoicesSteel}
              />
            </div>
          </>
        )}
      </Section>

      <Section title={t('thermal_calculator.continuous_layers')}>
        {/* Cladding */}
        <div>
          <QuestionWrapper>
            <OcLabel forId={`clad-${calcId}`} text={t('thermal_calculator.walls_above_grade.type_of_cladding')} />
            <DropdownField
              id={`clad-${calcId}`}
              name="type-of-cladding"
              value={cladding}
              onChange={e => setCladding(e.target.value)}
              options={
                studsKind === 'steel'
                  ? [
                      {
                        value: 'brickClay102',
                        text: `${t(
                          'thermal_calculator.walls_above_grade.brick'
                        )} (clay 102 mm, 4") with 25 mm air space`,
                      },
                    ]
                  : [
                      {
                        value: 'brickClay102',
                        text: `${t(
                          'thermal_calculator.walls_above_grade.brick'
                        )} (clay 102 mm, 4") with 25 mm air space`,
                      },
                      { value: 'vinylOverStrap', text: 'Vinyl/Wood siding over wood strapping' },
                      { value: 'vinylUnvented', text: 'Vinyl siding (unvented)' },
                      { value: 'hardieOverStrap', text: 'Hardie board (panel/plank) over wood strapping' },
                      { value: 'acrylicStuccoOverStrap', text: 'Acrylic stucco over wood strapping' },
                    ]
              }
            />
          </QuestionWrapper>

          {cladding === 'hardieOverStrap' && studsKind === 'wood' && (
            <SubQuestionWrapper>
              <OcLabel text={t('thermal_calculator.walls_above_grade.thickness_hardie_board')} />
              <RadioList
                name={`hardieThickness-${calcId}`}
                value={hardieThickness}
                onChange={setHardieThickness}
                options={[
                  { value: '6.35', label: '6.35 mm (1/4")' },
                  { value: '8', label: '8 mm (5/16")' },
                ]}
              />
            </SubQuestionWrapper>
          )}
        </div>

        {/* Sheathing material */}
        <div>
          <div>
            <OcLabel
              forId={`clad-${calcId}`}
              text={t('thermal_calculator.walls_above_grade.type_sheathing_material')}
            />
            <DropdownField
              id={`sheath-${calcId}`}
              name="type-sheathing-material"
              value={sheathingType}
              onChange={onSetSheathingType}
              options={[
                { value: 'osb', text: t('thermal_calculator.walls_above_grade.osb_sheathing') },
                { value: 'gwb', text: t('thermal_calculator.walls_above_grade.gypsum_sheathing') },
              ]}
            />
          </div>

          {sheathingType === 'osb' && (
            <SubQuestionWrapper>
              <OcLabel text={t('thermal_calculator.walls_above_grade.osb_sheathing_thickness')} />
              <RadioList
                name={`osbT-${calcId}`}
                value={osbThickness}
                onChange={setOsbThickness}
                options={[
                  { value: '9.5', label: '9.5 mm (3/8")' },
                  { value: '11', label: '11 mm (7/16")' },
                ]}
              />
            </SubQuestionWrapper>
          )}

          {sheathingType === 'gwb' && (
            <SubQuestionWrapper>
              <OcLabel text={t('thermal_calculator.walls_above_grade.gypsum_sheathing_thickness')} />
              <RadioList
                name={`gwbT-${calcId}`}
                value={gwbSheathThickness}
                onChange={setGwbSheathThickness}
                options={[
                  { value: '12.7', label: t('thermal_calculator.dimensions.gypsum_12_7') },
                  { value: '16', label: t('thermal_calculator.dimensions.gypsum_16') },
                ]}
              />
            </SubQuestionWrapper>
          )}

          {/* Exterior insulation */}
          <div>
            <SubQuestionWrapper>
              <OcLabel text={t('thermal_calculator.walls_above_grade.exterior_insulation')} />
              <YesNo
                name={`exterior-insulation-${calcId}`}
                value={hasExteriorInsulation}
                onChange={setHasExteriorInsulation}
              />
            </SubQuestionWrapper>

            {hasExteriorInsulation && (
              <div>
                <SubQuestionWrapper>
                  <OcLabel text={t('thermal_calculator.walls_above_grade.exterior_insulation_thickness')} />
                  <DropdownField
                    id={`extType-${calcId}`}
                    name="exterior-insulation-thickness"
                    value={exteriorInsulationType}
                    onChange={e => setExteriorInsulationType(e.target.value)}
                    options={[
                      { value: 'codebord', text: t('thermal_calculator.walls_above_grade.codebord') },
                      { value: 'rainbarrier', text: t('thermal_calculator.walls_above_grade.rainbarrier_ci_80') },
                    ]}
                  />
                </SubQuestionWrapper>

                {exteriorInsulationType === 'codebord' ? (
                  <SubQuestionWrapper>
                    <OcLabel text={t('thermal_calculator.walls_above_grade.select_codebord_thickness')} />
                    <DropdownField
                      id={`ext-codebord-${calcId}`}
                      name="select-codebord-thickness"
                      value={exteriorCodebordInches}
                      onChange={e => setExteriorCodebordInches(e.target.value)}
                      options={CODEBORD_THICKNESS_OPTIONS}
                    />
                  </SubQuestionWrapper>
                ) : (
                  <SubQuestionWrapper>
                    <OcLabel text={t('thermal_calculator.walls_above_grade.rainbarrier_thickness')} />
                    <DropdownField
                      id={`ext-rain-barrier-${calcId}`}
                      name="rainbarrier-thickness"
                      value={exteriorRainbarrierInches}
                      onChange={e => setExteriorRainbarrierInches(e.target.value)}
                      options={RAINBARRIER_THICKNESS_OPTIONS}
                    />
                  </SubQuestionWrapper>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Membranes */}
        <QuestionWrapper>
          <OcLabel text={t('thermal_calculator.walls_above_grade.sheathing_membrane')} />
          <YesNo name={`weatherBarrier-${calcId}`} value={hasWeatherBarrier} onChange={setHasWeatherBarrier} />
        </QuestionWrapper>

        <QuestionWrapper>
          <OcLabel text={t('thermal_calculator.walls_above_grade.polyethylene_vapour_barrier')} />
          <YesNo name={`vapourBarrier-${calcId}`} value={hasVapourBarrier} onChange={setHasVapourBarrier} />
        </QuestionWrapper>

        {/* Interior face */}
        <QuestionWrapper>
          <OcLabel text={t('thermal_calculator.walls_above_grade.gypsum_board_thickness_wall')} />
          <RadioList
            name={`interiorGwb-${calcId}`}
            value={interiorGWB}
            onChange={setInteriorGWB}
            options={[
              { value: '12.7', label: t('thermal_calculator.dimensions.gypsum_12_7') },
              { value: '16', label: t('thermal_calculator.dimensions.gypsum_16') },
            ]}
          />
        </QuestionWrapper>

        {/* Strapping */}
        <QuestionWrapper>
          <OcLabel text={t('thermal_calculator.walls_above_grade.wood_strapping_behind')} />
          <YesNo name={`strapBehindGwb-${calcId}`} value={woodStrapBehindGWB} onChange={setWoodStrapBehindGWB} />
        </QuestionWrapper>

        {/* Actions */}
        <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
          <CTAButton
            onClick={onCalculate}
            disabled={!hasLocation}
            text={t('thermal_calculator.calculate_r_value')}
            style={{ minWidth: '200px' }}
            data-track="calculate"
          />
          <CTAButton
            element="button"
            type="button"
            onClick={onReset}
            text={t('thermal_calculator.reset')}
            style={{
              minWidth: '100px',
              padding: '8px 16px',
              border: '1px solid #ccc',
              background: '#fff',
              color: '#000',
            }}
          />
        </div>
      </Section>
    </>
  );
};
/* eslint-enable react/prop-types */
